var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeeLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -1,
    width: 24,
    height: 19
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 8,
    height: 10
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 8,
    height: 10
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 5,
    width: 8,
    height: 10
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 8,
    height: 9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 8,
    height: 9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 5,
    width: 8,
    height: 9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 6.50006 7.74981 3.0001 12.2501 3.0001 14.0001 6.50006 12.2501 10 7.74981 10Z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.49985 13.75 5.99984 18.2499 5.99984 19.9999 9.49985 18.2499 12.9999 13.75 12.9999Z",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 9.49985 1.75 5.99984 6.2499 5.99984 7.9999 9.49985 6.2499 12.9999 1.75 12.9999Z",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 13.4999 7.74981 9.99997 12.2501 9.99997 14.0001 13.4999 12.2501 16.9999 7.74981 16.9999Z",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5.99984,
    y: 13.0001,
    width: 8.00026,
    height: 1.00003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.99987,
    y: 15.0001,
    width: 6.0002,
    height: 1.00003
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.99987,
    y: 11,
    width: 6.0002,
    height: 1.00003
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5833 5.4166 5.4166 5.4166 5.4166 2.5833 2.5833 2.5833ZM2.74997 2.74997 5.24994 2.74997 5.24994 5.24994 2.74997 5.24994Z",
    transform: "matrix(1 0 0 1.00005 0 5.99984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 2.41664 6.99991 2.24997 6.24992 2.24997 6.24992 2.16664C6.24965 1.93663 6.06327 1.75025 5.83326 1.74998L5.74993 1.74998 5.74993 0.999988 5.58326 0.999988 5.58326 1.74998 5.08327 1.74998 5.08327 0.999988 4.91661 0.999988 4.91661 1.74998 4.41661 1.74998 4.41661 0.999988 4.24995 0.999988 4.24995 1.74998 3.74995 1.74998 3.74995 0.999988 3.58329 0.999988 3.58329 1.74998 3.0833 1.74998 3.0833 0.999988 2.91663 0.999988 2.91663 1.74998 2.41664 1.74998 2.41664 0.999988 2.24997 0.999988 2.24997 1.74998 2.16664 1.74998C1.93663 1.75025 1.75025 1.93663 1.74998 2.16664L1.74998 2.24997 0.999988 2.24997 0.999988 2.41664 1.74998 2.41664 1.74998 2.91663 0.999988 2.91663 0.999988 3.0833 1.74998 3.0833 1.74998 3.58329 0.999988 3.58329 0.999988 3.74995 1.74998 3.74995 1.74998 4.24995 0.999988 4.24995 0.999988 4.41661 1.74998 4.41661 1.74998 4.91661 0.999988 4.91661 0.999988 5.08327 1.74998 5.08327 1.74998 5.58326 0.999988 5.58326 0.999988 5.74993 1.74998 5.74993 1.74998 5.83326C1.75025 6.06327 1.93663 6.24965 2.16664 6.24992L2.24997 6.24992 2.24997 6.99991 2.41664 6.99991 2.41664 6.24992 2.91663 6.24992 2.91663 6.99991 3.0833 6.99991 3.0833 6.24992 3.58329 6.24992 3.58329 6.99991 3.74995 6.99991 3.74995 6.24992 4.24995 6.24992 4.24995 6.99991 4.41661 6.99991 4.41661 6.24992 4.91661 6.24992 4.91661 6.99991 5.08327 6.99991 5.08327 6.24992 5.58326 6.24992 5.58326 6.99991 5.74993 6.99991 5.74993 6.24992 5.83326 6.24992C6.06327 6.24965 6.24965 6.06327 6.24992 5.83326L6.24992 5.74993 6.99991 5.74993 6.99991 5.58326 6.24992 5.58326 6.24992 5.08327 6.99991 5.08327 6.99991 4.91661 6.24992 4.91661 6.24992 4.41661 6.99991 4.41661 6.99991 4.24995 6.24992 4.24995 6.24992 3.74995 6.99991 3.74995 6.99991 3.58329 6.24992 3.58329 6.24992 3.0833 6.99991 3.0833 6.99991 2.91663 6.24992 2.91663 6.24992 2.41664ZM6.08326 5.83326C6.08326 5.97133 5.97133 6.08326 5.83326 6.08326L2.16664 6.08326C2.02857 6.08326 1.91664 5.97133 1.91664 5.83326L1.91664 2.16664C1.91664 2.02857 2.02857 1.91664 2.16664 1.91664L5.83326 1.91664C5.97133 1.91664 6.08326 2.02857 6.08326 2.16664Z",
    transform: "matrix(1 0 0 1.00005 0 5.99984)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.26049 4.73974 4.73974 4.73974 4.73974 2.26049 2.26049 2.26049ZM2.40633 2.40633 4.5939 2.40633 4.5939 4.5939 2.40633 4.5939Z",
    transform: "matrix(1.14281 0 0 1 12 5.99984)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1252 2.11465 6.1252 1.96881 5.46893 1.96881 5.46893 1.8959C5.46869 1.69463 5.3056 1.53154 5.10433 1.5313L5.03141 1.5313 5.03141 0.875029 4.88558 0.875029 4.88558 1.5313 4.44806 1.5313 4.44806 0.875029 4.30222 0.875029 4.30222 1.5313 3.86471 1.5313 3.86471 0.875029 3.71887 0.875029 3.71887 1.5313 3.28136 1.5313 3.28136 0.875029 3.13552 0.875029 3.13552 1.5313 2.698 1.5313 2.698 0.875029 2.55217 0.875029 2.55217 1.5313 2.11465 1.5313 2.11465 0.875029 1.96881 0.875029 1.96881 1.5313 1.8959 1.5313C1.69463 1.53154 1.53154 1.69463 1.5313 1.8959L1.5313 1.96881 0.875029 1.96881 0.875029 2.11465 1.5313 2.11465 1.5313 2.55217 0.875029 2.55217 0.875029 2.698 1.5313 2.698 1.5313 3.13552 0.875029 3.13552 0.875029 3.28136 1.5313 3.28136 1.5313 3.71887 0.875029 3.71887 0.875029 3.86471 1.5313 3.86471 1.5313 4.30222 0.875029 4.30222 0.875029 4.44806 1.5313 4.44806 1.5313 4.88558 0.875029 4.88558 0.875029 5.03141 1.5313 5.03141 1.5313 5.10433C1.53154 5.3056 1.69463 5.46869 1.8959 5.46893L1.96881 5.46893 1.96881 6.1252 2.11465 6.1252 2.11465 5.46893 2.55217 5.46893 2.55217 6.1252 2.698 6.1252 2.698 5.46893 3.13552 5.46893 3.13552 6.1252 3.28136 6.1252 3.28136 5.46893 3.71887 5.46893 3.71887 6.1252 3.86471 6.1252 3.86471 5.46893 4.30222 5.46893 4.30222 6.1252 4.44806 6.1252 4.44806 5.46893 4.88558 5.46893 4.88558 6.1252 5.03141 6.1252 5.03141 5.46893 5.10433 5.46893C5.3056 5.46869 5.46869 5.3056 5.46893 5.10433L5.46893 5.03141 6.1252 5.03141 6.1252 4.88558 5.46893 4.88558 5.46893 4.44806 6.1252 4.44806 6.1252 4.30222 5.46893 4.30222 5.46893 3.86471 6.1252 3.86471 6.1252 3.71887 5.46893 3.71887 5.46893 3.28136 6.1252 3.28136 6.1252 3.13552 5.46893 3.13552 5.46893 2.698 6.1252 2.698 6.1252 2.55217 5.46893 2.55217 5.46893 2.11465ZM5.32309 5.10433C5.32309 5.22515 5.22515 5.32309 5.10433 5.32309L1.8959 5.32309C1.77508 5.32309 1.67714 5.22515 1.67714 5.10433L1.67714 1.8959C1.67714 1.77508 1.77508 1.67714 1.8959 1.67714L5.10433 1.67714C5.22515 1.67714 5.32309 1.77508 5.32309 1.8959Z",
    transform: "matrix(1.14281 0 0 1 12 5.99984)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0C7.43296 -8.91177e-16 8.99993 1.56697 8.99993 3.49993",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.49993 0C5.43289 -8.91177e-16 6.99987 1.34311 6.99987 2.99992",
    stroke: "#000000",
    strokeWidth: 2.29167,
    strokeMiterlimit: 8,
    fill: "none",
    fillRule: "evenodd",
    transform: "matrix(-1 0 0 1 17.9999 0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeeLogo);
export default __webpack_public_path__ + "static/media/bee_logo.4c1ec9c457a9b4bd13c05d9dfcddaab0.svg";
export { ForwardRef as ReactComponent };